#!/usr/bin/env node

/**
 * MCP server entry point for spacecode.
 *
 * Runs the MCP server over stdio transport, allowing the coding agent
 * to use remote task execution tools programmatically.
 *
 * Usage:
 *   node dist/mcp/index.js
 */

import { StdioServerTransport } from '@modelcontextprotocol/sdk/server/stdio.js';
import { createServer } from './server.js';

async function main(): Promise<void> {
  const server = createServer();
  const transport = new StdioServerTransport();
  await server.connect(transport);
}

main().catch((error: unknown) => {
  console.error('MCP server error:', error);
  process.exit(1);
});
